export default __webpack_public_path__ + "img/LrjRVTcQ.5f59ae9d.svg";